






































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListRatesLunch } from '@/components/config'

// services
import { RatesLunchService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// models
import { FormRateLunch, RateLunch } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditRateLunch from './modalCreateEdit.vue'

const newItem: FormRateLunch = {
  name: '',
  price: 0,
  is_active: true
}

@Component({
  name: 'RatesLunchIndex',
  components: {
    PageHeader,
    TableListRatesLunch,
    ModalCreateEditRateLunch
  }
})
export default class RatesLunchIndex extends Vue {
  showModal = false
  rateLanch: FormRateLunch = newItem
  title = 'Tarifas de Refrigerio'
  actionForm = 'save'
  idItemEdit: number|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Tarifas de Refrigerio',
      active: true
    }
  ]

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.rateLanch = newItem
    this.showModal = true
  }

  editItem (rateLunch: RateLunch) {
    this.rateLanch = {
      name: rateLunch.name,
      price: rateLunch.price,
      is_active: rateLunch.is_active
    }
    if (rateLunch.id) {
      this.idItemEdit = Number(rateLunch.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (rateLunch: RateLunch) {
    const msg = `Seguro que desea eliminar la tarifa de refrigerio: ${rateLunch.name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && rateLunch.id) {
      loading('show')
      await RatesLunchService.delete(rateLunch.id)
      alerts.success()
      this.tableList.getRatesLunchWithPagination()
      loading('hide')
    }
  }

  async changeStatus (infoRateLunch: {id: number; status: boolean}) {
    loading('show')
    try {
      await RatesLunchService.changeStatus(infoRateLunch.id, infoRateLunch.status)
      alerts.success()
      this.tableList.getRatesLunchWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  get tableList (): Vue & { getRatesLunchWithPagination: () => void } {
    return this.$refs.table_rates_lunch as Vue & { getRatesLunchWithPagination: () => void }
  }
}
